<script>
  import { useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  import Header from "lib/components/Header.svelte";
  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    Pagination,
    Checkbox,
  } from "carbon-components-svelte";
  import ContentSwitcherNew from "lib/components/ContentSwitcher.svelte";
  import { Accordion, SectionWrapper, Button } from "paxray-components-svelte";
  import { hslToHex } from "lib/util/formatfunctions.js";
  import ActivitySelection from "./ActivitySelection.svelte";
  import ApplicationSelection from "../analysis/components/ApplicationSelection.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { fetchWrapper } from "lib/util/fetchWrapper.js";
  import ActivityModal from "./ActivityModal.svelte";
  import { ARROW_LEFT_ICON, EDIT_ICON } from "@utils/icons.js";

  // TO CHANGE
  export let analysisid;
  let page = 1;
  let elementPage = 1;
  let windowPage = 1;

  let activityId = 0;
  let activityname = "";
  let selectedWindows = [];
  let primaryWindows = [];
  let secondaryWindows = [];
  let elementFilteredRowIds = [];
  let windowFilteredRowIds = [];
  let pageSize = 15;
  let filteredRowIds = [];
  let windowtitles = [];
  let partitionlabel = [];
  let uielements = [];
  let selectedUIElement = [];
  let activitiesList = [];
  let appSelecFilterValues = [];
  let editActivityName = "";
  let editActivityColor = "";
  let uielementsLoading = false;
  let searchTerm = "";
  let searchTermStartEndEvent = "";

  let startEndEventIndex = 0;

  let startEvents = [];
  let endEvents = [];
  let headers = [];
  let rows = [];
  let color = getRandomColor();
  let allwindowtitles = [];
  let onlySelected = 0;
  let onlyUnmappedCases = false;
  let onlyUnmappedProcesses = false;
  let onlyUnmapped = false;
  let modalEditOpen = false;

  const navigate = useNavigate();

  $: {
    if (startEndEventIndex === 0) {
      headers = [
        { key: "primary", value: "P", width: "60px" },
        { key: "secondary", value: "S", width: "60px" },
        { key: "clearname", value: "Application", width: "150px" },
        { key: "windowtitle", value: "Window Title", width: "auto" },
        { key: "count", value: "Count", width: "100px" },
        { key: "activityname", value: "Activity", width: "auto" },
        { key: "edit", value: "", width: "60px" },
      ];
      setRows();
      rows = [...windowtitles];
    } else {
      headers = [
        { key: "clearname", value: "Application" },
        { key: "windowtitle", value: "Window Title" },
        { key: "activityname", value: "Activity" },
      ];
      setRows();
      rows = windowtitles.filter((element) =>
        element.activitiesList.some((activity) => activity.id === activityId),
      );
    }
  }

  $: getApplog();
  $: getMappedActivities();

  $: if (activityId !== 0) {
    partitionlabel = [];
    applyEndEventFilters();
  }

  $: if (activityId === 0) {
    primaryWindows = [];
    secondaryWindows = [];
  }

  $: if (windowtitles.length > 0 || activitiesList.length > 0) {
    setRows();
  }

  $: selectedWindows = new Set([...primaryWindows, ...secondaryWindows]);

  $: {
    if (activityId && startEndEventIndex === 0) {
      loadActivity();
    } else if (activityId && startEndEventIndex > 0) {
      activityId = activityId;
      applyEndEventFilters();
    } else {
      createNewActivity();
    }
  }

  $: {
    if (appSelecFilterValues.length > 0) {
      windowtitles = allwindowtitles.filter((element) =>
        appSelecFilterValues.includes(element.clearname),
      );
    } else {
      windowtitles = allwindowtitles;
    }
  }

  $: {
    if (
      !onlySelected &&
      !onlyUnmappedCases &&
      !onlyUnmappedProcesses &&
      !onlyUnmapped &&
      (!searchTerm || searchTerm.trim() === "")
    ) {
      windowtitles = allwindowtitles;
      filteredRowIds = allwindowtitles.map((element) => element.id);
    } else {
      updateFilters();
    }
    selectedWindows = selectedWindows;
  }

  $: {
    if (activitiesList.length > 0) {
      sortActivitiesByName();
    }
  }

  function updateFilters() {
    let tempTitles = allwindowtitles;
    if (onlySelected) {
      tempTitles = tempTitles.filter((element) =>
        selectedWindows.has(element.id),
      );
    }
    if (onlyUnmappedCases) {
      tempTitles = tempTitles.filter(
        (element) => element.unmappedActivityCases,
      );
    }
    if (onlyUnmappedProcesses) {
      tempTitles = tempTitles.filter(
        (element) => element.unmappedActivityProcesses,
      );
    }
    if (onlyUnmapped) {
      tempTitles = tempTitles.filter((element) => element.unmappedActivity);
    }

    if (searchTerm) {
      tempTitles = tempTitles.filter((element) =>
        element.windowtitle.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }
    windowtitles = tempTitles;
    filteredRowIds = tempTitles.map((element) => element.id);
  }

  function setRows() {
    windowtitles.forEach((windowtitle) => {
      windowtitle.activityname = null;
      windowtitle.color = null;
      windowtitle.activityId = null;
      windowtitle.activitiesList = [];
    });
    activitiesList.forEach((activity) => {
      activity.windowtitles.forEach((wintitle) => {
        const windowtitle = windowtitles.find(
          (element) =>
            element.windowtitle === wintitle.windowtitle &&
            element.clearname === wintitle.applicationname,
        );
        if (windowtitle) {
          windowtitle.activityname = activity.activityname;
          windowtitle.color = activity.color;
          windowtitle.activityId = activity.id;
          windowtitle.activitiesList.push({
            activityname: activity.activityname,
            color: activity.color,
            id: activity.id,
            windowtype: wintitle.windowtype,
          });
        }
      });
    });
    rows = [...windowtitles];
    if (startEndEventIndex > 0) {
      if (!activityId) {
        activityId = activitiesList[0]?.id;
      }
      rows = windowtitles.filter((element) =>
        element.activitiesList.some((activity) => activity.id === activityId),
      );
    }
    if (searchTermStartEndEvent && searchTermStartEndEvent.trim() !== "") {
      rows = rows.filter(
        (element) =>
          element.windowtitle
            .toLowerCase()
            .includes(searchTermStartEndEvent.toLowerCase()) ||
          element.clearname
            .toLowerCase()
            .includes(searchTermStartEndEvent.toLowerCase()),
      );
    }
    filteredRowIds = [...rows.map((element) => element.id)];
  }

  function applyEndEventFilters() {
    let tempRows = windowtitles.filter((element) =>
      element.activitiesList.some((activity) => activity.id === activityId),
    );

    if (searchTermStartEndEvent && searchTermStartEndEvent.trim() !== "") {
      tempRows = tempRows.filter(
        (element) =>
          element.windowtitle
            .toLowerCase()
            .includes(searchTermStartEndEvent.toLowerCase()) ||
          element.clearname
            .toLowerCase()
            .includes(searchTermStartEndEvent.toLowerCase()),
      );
    }

    rows = tempRows;
    windowFilteredRowIds = tempRows.map((element) => element.id);
  }

  function setEventsToUIElements() {
    startEvents = [];
    endEvents = [];

    const activity = activitiesList.find(
      (activity) => activity.id === activityId,
    );

    if (activity) {
      const startEventsMap = new Map();
      const endEventsMap = new Map();

      activity.startEvents.forEach((event) => {
        const key = `${event.applicationname}-${event.windowtitle}-${event.name}`;
        startEventsMap.set(key, true);
      });

      activity.endEvents.forEach((event) => {
        const key = `${event.applicationname}-${event.windowtitle}-${event.name}`;
        endEventsMap.set(key, true);
      });

      uielements.forEach((element) => {
        const key = `${element.clearname}-${element.windowtitle}-${element.name}`;
        const newStartValue = startEventsMap.has(key) || false;
        const newEndValue = endEventsMap.has(key) || false;

        if (element.start !== newStartValue) {
          element.start = newStartValue;
        }
        if (element.end !== newEndValue) {
          element.end = newEndValue;
        }
      });

      startEvents = activity.startEvents;
      endEvents = activity.endEvents;
    } else {
      uielements.forEach((element) => {
        element.start = false;
        element.end = false;
      });
    }
    uielements = [...uielements];
  }

  function loadActivity() {
    fetchWithSession(`/api/analysis/getMappedActivity/${activityId}`)
      .then((res) => res.json())
      .then((data) => {
        activityname = data.activityname;
        editActivityName = data.activityname;
        color = data.color;
        editActivityColor = data.color;
        startEvents = data.startEvents;
        endEvents = data.endEvents;
        primaryWindows = data.windowtitles
          .filter(
            (element) =>
              element.windowtype === "primary" || element.windowtype === null,
          )
          .map((element) => {
            const foundElement = allwindowtitles.find(
              (el) =>
                el.clearname === element.applicationname &&
                el.windowtitle === element.windowtitle,
            );
            return foundElement ? foundElement.id : undefined;
          })
          .filter((id) => id !== undefined);
        secondaryWindows = data.windowtitles
          .filter((element) => element.windowtype === "secondary")
          .map((element) => {
            const foundElement = allwindowtitles.find(
              (el) =>
                el.clearname === element.applicationname &&
                el.windowtitle === element.windowtitle,
            );
            return foundElement ? foundElement.id : undefined;
          })
          .filter((id) => id !== undefined);
        selectedWindows = new Set([...primaryWindows, ...secondaryWindows]);
      })
      .finally(() => {
        updateFilters();
      });
  }

  function createNewActivity() {
    color = getRandomColor();
    activityname = "";
    partitionlabel = [];
    selectedUIElement = [];
    startEvents = [];
    endEvents = [];
    selectedWindows = [];
    activityId = 0;
  }

  function saveCurrentActivity() {
    const startEvents = activitiesList.find(
      (activity) => activity.id === activityId,
    ).startEvents;
    const endEvents = activitiesList.find(
      (activity) => activity.id === activityId,
    ).endEvents;
    const combinedWindows = [...primaryWindows, ...secondaryWindows];
    let data = {
      id: activityId,
      activityname: editActivityName,
      color: editActivityColor,
      endEvents: endEvents.map((ee) => {
        const { applicationname, clearname, ...rest } = ee;
        return { ...rest, clearname: clearname || applicationname };
      }),
      startEvents: startEvents.map((se) => {
        const { applicationname, clearname, ...rest } = se;
        return { ...rest, clearname: clearname || applicationname };
      }),
      windowtitles: combinedWindows.map((element) => {
        let windowtitle = allwindowtitles.filter(
          (windowtitle) => windowtitle.id == element,
        )[0];
        if (windowtitle) {
          windowtitle.windowtype = primaryWindows.includes(element)
            ? "primary"
            : "secondary";
        }
        return windowtitle;
      }),
      analysisid: analysisid,
    };
    if (activityId == 0 && activityname) {
      saveActivity(data);
    } else {
      updateActivity(data);
    }
    getApplog();
  }

  function saveActivity(data) {
    fetchWithSession(`/api/analysis/addMappedActivity`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.text())
      .then((res) => {
        activityId = res;
        data.id = res;
        activitiesList.push(data);
        activitiesList = activitiesList;
        getMappedActivities();
      });
  }

  async function updateActivity(data) {
    fetchWithSession(`/api/analysis/updateMappedActivity`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        let index = activitiesList.findIndex(
          (element) => element.id === data.id,
        );
        activitiesList[index] = data;
        activityId = activityId;
        getMappedActivities();
      });
  }

  async function getApplog() {
    try {
      const response = await fetchWithSession(
        `/api/analysis/getWindowPartitionsUnmapped?analysisid=` + analysisid,
      );
      const data = await response.json();
      allwindowtitles = data;
      windowtitles = data;
      windowtitles.forEach((element) => {
        element.activityname = null;
        element.color = null;
        element.activityId = null;
      });
    } catch (error) {
      console.error("Error fetching window partitions:", error);
    }
  }

  function getMappedActivities() {
    fetchWithSession(`/api/analysis/getMappedActivities/` + analysisid)
      .then((res) => res.json())
      .then((data) => {
        activitiesList = data;
        setRows();
      });
  }

  function exportMappedActivities() {
    fetchWrapper(`/api/analysis/exportMappedActivities/` + analysisid, {
      headers: { ...session.authorizationHeader },
    })
      .then((res) => res.text())
      .then((data) => {
        const element = document.createElement("a");
        const file = new Blob([data], { type: "text/plain" });
        element.href = URL.createObjectURL(file);
        element.download = "mappedActivities.json";
        document.body.appendChild(element);
        element.click();
      });
  }

  function importMappedActivities() {
    const file = importuploader.files[0];
    const reader = new FileReader();
    reader.onload = async function (e) {
      const text = e.target.result;
      const data = JSON.parse(text);
      fetchWrapper(`/api/analysis/importMappedActivities/` + analysisid, {
        method: "POST",
        headers: {
          ...session.authorizationHeader,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((data) => {
          activitiesList = data;
          setRows();
        });
    };
    reader.readAsText(file);
  }

  function sortActivitiesByName() {
    activitiesList.sort((a, b) => a.activityname.localeCompare(b.activityname));
  }

  function getUIelements(partitionlabel) {
    if (partitionlabel.length == 0) return;
    uielementsLoading = true;
    fetchWithSession(
      `/api/analysis/windowPartitioElements/${analysisid}/${partitionlabel[0]}`,
    )
      .then((res) => res.json())
      .then((data) => {
        uielements = data;
        setEventsToUIElements();
      })
      .finally(() => {
        uielementsLoading = false;
      });
  }

  async function addStartEndEvent(event, row) {
    let uielement = uielements.filter((element) => element.id == row.id)[0];
    let application = windowtitles.filter(
      (element) => element.id == partitionlabel[0],
    )[0];
    let activity = activitiesList.filter(
      (element) => element.id == activityId,
    )[0];
    endEvents = endEvents.map((ee) => {
      const { applicationname, clearname, ...rest } = ee;
      return { ...rest, clearname: clearname || applicationname };
    });
    startEvents = startEvents.map((se) => {
      const { applicationname, clearname, ...rest } = se;
      return { ...rest, clearname: clearname || applicationname };
    });
    if (event == "end") {
      endEvents.push({
        applicationname: application.applicationname,
        clearname: application.clearname,
        windowtitle: application.windowtitle,
        name: uielement.name,
        automationid: uielement.automationid,
        activityId: activityId,
        eventtype: "end",
      });
      endEvents = endEvents;
    } else if (event == "start") {
      startEvents.push({
        applicationname: application.applicationname,
        clearname: application.clearname,
        windowtitle: application.windowtitle,
        name: uielement.name,
        automationid: uielement.automationid,
        activityId: activityId,
        eventtype: "start",
      });
      startEvents = startEvents;
    }

    let data = {
      id: activityId,
      activityname: activity.activityname,
      color: activity.color,
      startEvents: startEvents,
      endEvents: endEvents,
      windowtitles: activity.windowtitles.map((wt) => {
        const { applicationname, clearname, ...rest } = wt;
        return { ...rest, clearname: clearname || applicationname };
      }),
      analysisid: analysisid,
    };
    updateActivity(data);
  }

  async function removeStartEndEvent(event, row) {
    let activity = activitiesList.filter(
      (element) => element.id == activityId,
    )[0];
    if (event == "end") {
      endEvents = activity.endEvents.filter(
        (element) =>
          element.windowtitle !== row.windowtitle ||
          element.name !== row.name ||
          element.automationid !== row.automationid,
      );
      endEvents = endEvents;
    } else if (event == "start") {
      startEvents = activity.startEvents.filter(
        (element) =>
          element.windowtitle !== row.windowtitle ||
          element.name !== row.name ||
          element.automationid !== row.automationid,
      );
      startEvents = startEvents;
    }
    let data = {
      id: activityId,
      activityname: activity.activityname,
      color: activity.color,
      startEvents: startEvents.map((se) => {
        const { applicationname, clearname, ...rest } = se;
        return { ...rest, clearname: clearname || applicationname };
      }),
      endEvents: endEvents.map((ee) => {
        const { applicationname, clearname, ...rest } = ee;
        return { ...rest, clearname: clearname || applicationname };
      }),
      windowtitles: activity.windowtitles.map((wt) => {
        const { applicationname, clearname, ...rest } = wt;
        return { ...rest, clearname: clearname || applicationname };
      }),
      analysisid: analysisid,
    };
    updateActivity(data);
  }

  function getRandomColor() {
    return hslToHex(Math.random() * 360, 1, 0.75);
  }

  async function handleAddRemoveEvents(type, row) {
    if (type === "start") {
      row.start = !row.start;
      uielements = [...uielements];
      if (!row.start) removeStartEndEvent(type, row);
      else addStartEndEvent(type, row);
    } else if (type === "end") {
      row.end = !row.end;
      uielements = [...uielements];
      if (!row.end) removeStartEndEvent(type, row);
      else addStartEndEvent(type, row);
    }
  }

  let importuploader;
</script>

<Header section="Mapping Assistant" breadcrumb="Activity Mapping">
  <Button
    on:click={() => {
      importuploader.click();
    }}
    kind="secondary"
    text="Import Mapping"
  />
  <input
    type="file"
    bind:this={importuploader}
    style="display:none;"
    on:change={importMappedActivities}
  />
  <Button
    on:click={exportMappedActivities}
    kind="secondary"
    text="Export Mapping"
  />
  <Button
    kind="secondary"
    text="Mask Analysis"
    on:click={() => {
      window.open(
        `${ROUTES.analysis.heatmap}?analysisid=${analysisid}`,
        "_blank",
      );
    }}
  />
  <Button
    text="Back"
    on:click={() => {
      navigate(`${ROUTES.dam.mappingAssistant}?analysisid=${analysisid}`);
    }}
    iconLeft={true}
    icon={ARROW_LEFT_ICON}
    kind="secondary"
  />
</Header>

<SectionWrapper fitScreen={true}>
  <div slot="main" style="width:100%;">
    <div style="display:flex; flex-direction:row; gap:1rem;">
      <div style="flex-grow:1; max-width:50%;">
        <ContentSwitcherNew
          options={["Windowtitles", "Start/End Event"]}
          bind:selected={startEndEventIndex}
        />
      </div>
    </div>
    {#if startEndEventIndex == 0}
      <Checkbox bind:checked={onlySelected} labelText="Show only selected" />
      <Checkbox
        bind:checked={onlyUnmappedCases}
        labelText="Show only Windows with Objects"
      />
      <Checkbox
        bind:checked={onlyUnmappedProcesses}
        labelText="Show only Windows with Processes or Automations"
      />
      <Checkbox
        bind:checked={onlyUnmapped}
        labelText="Show only unmapped Windows"
      />
      <DataTable size="compact" sortable {pageSize} {page} {headers} {rows}>
        <Toolbar>
          <ToolbarContent>
            <ToolbarSearch
              bind:filteredRowIds
              shouldFilterRows={(row, value) => {
                return true;
              }}
              bind:value={searchTerm}
              on:input={() => {
                updateFilters();
              }}
              on:clear={() => {
                searchTerm = "";
                updateFilters();
              }}
            />
            <Button
              text="Save"
              kind="secondary"
              on:click={saveCurrentActivity}
              disabled={!activityId}
            />
          </ToolbarContent>
        </Toolbar>
        <svelte:fragment slot="cell" let:row let:cell>
          {#if cell.key === "activityname" && cell.value}
            <div
              style="display: flex; align-items: center; flex-wrap: wrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis;"
            >
              {#each row.activitiesList as activity}
                <div
                  style="display: flex; align-items: center; margin-right: 8px;"
                >
                  <div
                    style="width: 12px; height: 12px; background-color: {activity.color}; margin-right: 8px; border-radius: 0.25rem;"
                  ></div>
                  {#if activity.windowtype === "secondary"}
                    (S) {activity.activityname}
                  {:else}
                    {activity.activityname}
                  {/if}
                </div>
              {/each}
            </div>
          {:else if cell.key === "count" || cell.key === "windowtitle" || cell.key === "clearname"}
            {cell.value}
          {:else if cell.key === "primary"}
            <div class="bx--checkbox--inline">
              <input
                type="checkbox"
                id={`checkbox-${row.id}-${cell.key}`}
                checked={primaryWindows.includes(row.id)}
                on:change={(e) => {
                  if (primaryWindows.includes(row.id)) {
                    primaryWindows = primaryWindows.filter(
                      (element) => element !== row.id,
                    );
                  } else {
                    primaryWindows = [...primaryWindows, row.id];
                  }
                }}
                class="bx--checkbox"
              />
              <label
                for={`checkbox-${row.id}-${cell.key}`}
                class="bx--checkbox-label"
              />
            </div>
          {:else if cell.key === "secondary"}
            <div class="bx--checkbox--inline">
              <input
                type="checkbox"
                id={`checkbox-${row.id}-${cell.key}`}
                checked={secondaryWindows.includes(row.id)}
                on:change={(e) => {
                  if (secondaryWindows.includes(row.id)) {
                    secondaryWindows = secondaryWindows.filter(
                      (element) => element !== row.id,
                    );
                  } else {
                    secondaryWindows = [...secondaryWindows, row.id];
                  }
                }}
                class="bx--checkbox"
              />
              <label
                for={`checkbox-${row.id}-${cell.key}`}
                class="bx--checkbox-label"
              />
            </div>
          {:else if cell.key === "edit"}
            <Button
              kind="secondary"
              icon={EDIT_ICON}
              size="small"
              on:click={async (e) => {
                e.stopPropagation();
                editActivityName = row.windowtitle;
                activityId = "";
                editActivityColor = getRandomColor();
                modalEditOpen = true;
              }}
            />
          {/if}
        </svelte:fragment>
      </DataTable>
      <Pagination
        bind:pageSize
        bind:page
        totalItems={filteredRowIds.length}
        pageSizes={[15, 30, 50]}
      />
    {/if}
    {#if startEndEventIndex > 0}
      <br />
      <DataTable
        size="compact"
        expandable
        sortable
        bind:selectedRowIds={partitionlabel}
        bind:expandedRowIds={partitionlabel}
        on:click:row--expand={(e) => {
          if (partitionlabel.length > 1) {
            partitionlabel = [e.detail.row.id];
          }
          getUIelements(partitionlabel);
        }}
        {pageSize}
        page={windowPage}
        {headers}
        {rows}
      >
        <Toolbar>
          <ToolbarContent>
            <ToolbarSearch
              shouldFilterRows={(row, value) => {
                return true;
              }}
              bind:filteredRowIds={windowFilteredRowIds}
              bind:value={searchTermStartEndEvent}
              on:input={() => {
                applyEndEventFilters();
              }}
              on:clear={() => {
                searchTermStartEndEvent = "";
                applyEndEventFilters();
              }}
            />
          </ToolbarContent>
        </Toolbar>
        <svelte:fragment slot="cell" let:row let:cell>
          {#if cell.key === "activityname" && cell.value}
            <div
              style="display: flex; align-items: center; flex-wrap: wrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis;"
            >
              {#each row.activitiesList as activity}
                <div
                  style="display: flex; align-items: center; margin-right: 8px;"
                >
                  <div
                    style="width: 12px; height: 12px; background-color: {activity.color}; margin-right: 8px; border-radius: 0.25rem;"
                  ></div>
                  {activity.activityname}
                </div>
              {/each}
            </div>
          {:else if cell.key === "windowtitle" || cell.key === "clearname"}
            {cell.value}
          {/if}
        </svelte:fragment>
        <div
          class="menu_wrapper interations start-end-table"
          slot="expanded-row"
          style="padding: 10px;"
        >
          {#if uielementsLoading}
            <div style="text-align: center; padding: 20px;">
              <p>Loading UI elements...</p>
            </div>
          {:else}
            {#key uielements}
              <DataTable
                size="compact"
                sortable
                {pageSize}
                page={elementPage}
                bind:selectedRowIds={selectedUIElement}
                headers={[
                  { key: "start", value: "Start" },
                  { key: "end", value: "End" },
                  { key: "type", value: "Type" },
                  { key: "name", value: "Name" },
                  { key: "automationid", value: "Automation ID" },
                ]}
                rows={uielements}
              >
                <svelte:fragment slot="cell" let:row let:cell>
                  {#if cell.key === "start"}
                    <div class="bx--radio-button-wrapper">
                      <input
                        type="checkbox"
                        id={`checkbox-${row.id}-${cell.key}`}
                        checked={row.start}
                        on:change={(e) => handleAddRemoveEvents(cell.key, row)}
                        class="bx--radio-button"
                      />
                      <label
                        for={`checkbox-${row.id}-${cell.key}`}
                        class="bx--radio-button__label"
                      >
                        <span class="bx--radio-button__appearance"></span>
                      </label>
                    </div>
                  {:else if cell.key === "end"}
                    <div class="bx--radio-button-wrapper">
                      <input
                        type="checkbox"
                        id={`checkbox-${row.id}-${cell.key}`}
                        checked={row.end}
                        on:change={(e) => handleAddRemoveEvents(cell.key, row)}
                        class="bx--radio-button"
                      />
                      <label
                        for={`checkbox-${row.id}-${cell.key}`}
                        class="bx--radio-button__label"
                      >
                        <span class="bx--radio-button__appearance"></span>
                      </label>
                    </div>
                  {:else}
                    {cell.value}
                  {/if}
                </svelte:fragment>
              </DataTable>
              <Pagination
                bind:pageSize
                bind:page={elementPage}
                totalItems={elementFilteredRowIds.length}
                pageSizeInputDisabled
              />
            {/key}
          {/if}
        </div>
      </DataTable>
      <Pagination
        bind:pageSize
        bind:page={windowPage}
        totalItems={windowFilteredRowIds.length}
        pageSizeInputDisabled
      />
      <br />
    {/if}
  </div>

  <div slot="menu" class="menu">
    <Accordion heading="Activities" open={true}>
      <ActivitySelection
        bind:startEvents
        bind:endEvents
        windowTitles={rows}
        displayCount="7"
        bind:activities={activitiesList}
        bind:selectedActivity={activityId}
        {analysisid}
        {updateActivity}
        {saveActivity}
        {primaryWindows}
        bind:editActivityColor
        bind:editActivityName
      />
    </Accordion>
    <Accordion heading="Applications" open={true}>
      <ApplicationSelection
        {rows}
        bind:selectedRows={filteredRowIds}
        bind:selectedApps={appSelecFilterValues}
        bind:editActivityColor
        activityMappingView={true}
      />
    </Accordion>
  </div>
</SectionWrapper>

<ActivityModal
  bind:modalOpen={modalEditOpen}
  bind:editActivityName
  bind:editActivityColor
  {analysisid}
  {updateActivity}
  {saveActivity}
  {primaryWindows}
></ActivityModal>

<style>
  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  :global(.start-end-table .bx--data-table thead th:first-child) {
    width: 60px;
    max-width: 60px;
  }

  :global(.start-end-table .bx--data-table thead th:nth-child(2)) {
    width: 50px;
    max-width: 60px;
  }
</style>
